import { render, staticRenderFns } from "./AudioCardSummary.vue?vue&type=template&id=05fa3533&"
import script from "./AudioCardSummary.vue?vue&type=script&lang=ts&"
export * from "./AudioCardSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports